"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function removeValue(values, indexToRemove) {
    return values.filter((_value, index) => indexToRemove !== index);
}
exports.default = removeValue;
